import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [NotificationComponent],
  imports: [
    CommonModule, SharedModule
  ],
  exports: [NotificationComponent]
})
export class NotificationModule { }
